module.exports = __webpack_public_path__ + "img/2.d698d301.png";